import { createMiddleware } from "@tanstack/react-start";
import { setResponseHeader } from "@tanstack/react-start/server";

/**
 * Baseline security headers on every portal response (SSR documents, server-fn RPCs, server
 * routes). The API sets its own; the portal is what serves the HTML, so framing protection has to
 * live here.
 *
 * - `frame-ancestors 'none'` + `X-Frame-Options: DENY`: no clickjacking (the modern directive and
 *   the legacy header for old browsers).
 * - `nosniff`: uploaded or proxied content is never MIME-sniffed into something executable.
 * - `strict-origin-when-cross-origin`: tokens in URLs (reset/invite/confirm links) never leak to
 *   third parties through the Referer header.
 *
 * A full script/style CSP is deliberately NOT set here yet (inline theme script, Sentry, OpenPanel
 * would all need nonces or hashes) — see backend/docs/security-open-gaps.md.
 */
export const securityHeadersMiddleware = createMiddleware().server(async ({ next }) => {
  setResponseHeader("Content-Security-Policy", "frame-ancestors 'none'");
  setResponseHeader("X-Frame-Options", "DENY");
  setResponseHeader("X-Content-Type-Options", "nosniff");
  setResponseHeader("Referrer-Policy", "strict-origin-when-cross-origin");
  return next();
});
